import { Button, Group } from '@mantine/core';
import { IconPlayerPlay } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { adminApi } from '@/api/admin';
import type { AdminVideo } from '@/api/types';
import { ErrorAlert } from '@/components/QueryState';
import { HlsPlayer } from './HlsPlayer';

/** "Play" button that fetches a signed HLS URL (POST /videos/{id}/playback) then shows the player. */
export function VideoPlayback({ video, label = 'Play' }: { video: AdminVideo; label?: string }) {
  const playback = useMutation({ mutationFn: () => adminApi.videoPlayback(video.id) });
  if (playback.data) return <HlsPlayer src={playback.data.url} title={video.title} />;
  return (
    <Group gap="xs">
      <Button
        variant="default"
        leftSection={<IconPlayerPlay size={16} />}
        onClick={() => playback.mutate()}
        loading={playback.isPending}
        disabled={video.status !== 'ready'}
      >
        {label}
      </Button>
      {playback.error && <ErrorAlert error={playback.error} title="Couldn't start playback" />}
    </Group>
  );
}
